import type { SVGProps } from "react";
export interface BreadShortIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function BreadShortIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: BreadShortIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M2.633 10.765a1.126 1.126 0 0 1 1.312-.743l.112.03 4.763 1.589a1.125 1.125 0 0 1-.71 2.134l-4.765-1.588-.107-.042a1.125 1.125 0 0 1-.605-1.38M5.089 7.34a1.126 1.126 0 0 1 1.313-.743l.111.031 5.49 1.831a1.124 1.124 0 0 1-.711 2.134l-5.49-1.83-.108-.042A1.126 1.126 0 0 1 5.09 7.34Zm3.487-3.08a1.126 1.126 0 0 1 1.312-.743l.112.03 5.185 1.729.107.042a1.126 1.126 0 0 1-.707 2.124l-.112-.03-5.185-1.729-.107-.042a1.125 1.125 0 0 1-.605-1.382Z"
      />
      <path
        fill={color}
        d="M14.409 1.203c2.596-.622 5.097-.375 6.68.885l.242.202c1.176 1.028 1.75 2.268 1.792 3.615.043 1.375-.47 2.735-1.169 3.967-1.393 2.452-3.803 4.852-5.517 6.566-1.713 1.713-4.113 4.123-6.565 5.516-1.232.7-2.592 1.212-3.967 1.17-1.348-.044-2.586-.618-3.615-1.794l-.202-.243c-1.26-1.583-1.507-4.082-.885-6.678.635-2.65 2.211-5.6 4.909-8.297l.508-.494c2.557-2.398 5.305-3.82 7.789-4.415m5.277 2.646c-.817-.65-2.492-1-4.753-.457-2.07.496-4.477 1.713-6.773 3.867l-.457.444c-2.432 2.432-3.782 5.022-4.311 7.23-.542 2.261-.194 3.937.457 4.754.69.866 1.403 1.163 2.127 1.186.786.025 1.722-.271 2.784-.874 2.136-1.213 4.316-3.382 6.087-5.152s3.939-3.951 5.152-6.087c.603-1.061.899-1.998.874-2.784-.02-.633-.25-1.26-.888-1.868l-.299-.26Z"
      />
    </svg>
  );
}
